var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('header',{staticClass:"section page-header"},[_c('CzMenu')],1),_vm._t("default"),_c('footer',{staticClass:"section footer-variant-2 footer-modern context-dark"},[_c('Footer')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }